{% block sw_cms_element_acris_blog_image_slider_config %}
    <div class="sw-cms-el-config-acris-blog-image-slider">
        {% block sw_cms_element_acris_blog_image_slider_config_settings_display_mode %}
            {% block sw_cms_element_acris_blog_image_slider_config_settings_display_mode_select %}
                <mt-select
                        v-model="element.config.addCoverImage.value"
                        class="sw-cms-el-config-acris-blog-image-slider__setting-add-cover-image"
                        :label="$t('acris-blog.elements.blogImageSlider.config.label.addCoverImage')"
                        :options="addCoverImageOptions"
                        @update:model-value="onChangeDisplayMode"
                />
            {% endblock %}

            <div class="sw-cms-el-config-acris-blog-image-slider__setting-option">
                {% block sw_cms_element_acris_blog_image_slider_config_settings_display_mode_select %}
                    <mt-select
                            v-model="element.config.displayMode.value"
                            class="sw-cms-el-config-acris-blog-image-slider__setting-display-mode"
                            :label="$t('sw-cms.elements.general.config.label.displayMode')"
                            :help-text="$t('sw-cms.elements.imageSlider.config.helpText.displayMode')"
                            :options="displayModeValueOptions"
                            @update:model-value="onChangeDisplayMode"
                    />
                {% endblock %}

                {% block sw_cms_element_acris_blog_image_slider_config_settings_min_height %}
                    <mt-text-field
                            v-model="element.config.minHeight.value"
                            :label="$t('sw-cms.elements.image.config.label.minHeight')"
                            :placeholder="$t('sw-cms.elements.image.config.label.minHeight')"
                            :help-text="$t('sw-cms.elements.image.config.label.minHeightHelpText')"
                            :disabled="element.config.displayMode.value !== 'cover'"
                            @update:model-value="onChangeMinHeight"
                    />
                {% endblock %}

                {% block sw_cms_element_acris_blog_image_slider_config_settings_vertical_align %}
                    <mt-select
                            v-model="element.config.verticalAlign.value"
                            :label="$t('sw-cms.elements.general.config.label.verticalAlign')"
                            :placeholder="$t('sw-cms.elements.general.config.label.verticalAlign')"
                            :disabled="element.config.displayMode.value === 'cover'"
                            :options="verticalAlignValueOptions"
                    />
                {% endblock %}
            </div>
        {% endblock %}

        {% block sw_cms_element_acris_blog_image_slider_config_settings_navigation %}
            <div class="sw-cms-el-config-acris-blog-image-slider__setting-navigations sw-cms-el-config-acris-blog-image-slider__setting-option">
                <div class="sw-cms-el-config-acris-blog-image-slider__settings-navigation">
                    {% block sw_cms_element_acris_blog_image_slider_config_settings_navigation_arrow_position %}
                        <mt-select
                                v-model="element.config.navigationArrows.value"
                                :label="$t('sw-cms.elements.imageSlider.config.label.navigationArrows')"
                                :options="navigationArrowsValueOptions"
                                @update:model-value="emitUpdateEl"
                        />
                    {% endblock %}
                </div>

                <div class="sw-cms-el-config-acris-blog-image-slider__settings-navigation">
                    {% block sw_cms_element_acris_blog_image_slider_config_settings_navigation_dots_position %}
                        <mt-select
                                v-model="element.config.navigationDots.value"
                                :label="$t('sw-cms.elements.imageSlider.config.label.navigationDots')"
                                :options="navigationDotsValueOptions"
                                @update:model-value="emitUpdateEl"
                        />
                    {% endblock %}
                </div>
            </div>
        {% endblock %}

        <div class="sw-cms-el-config-acris-blog-image-slider__setting-speed">
            {% block sw_cms_element_acris_blog_image_slider_config_settings_speed %}
                <mt-number-field
                        v-model="element.config.speed.value"
                        class="sw-cms-el-config-acris-blog-image-slider__setting-speed-slide"
                        number-type="int"
                        :min="0"
                        :max="3600000"
                        :label="$t('sw-cms.elements.general.config.label.speed')"
                        :placeholder="$t('sw-cms.elements.general.config.label.speed')"
                        :help-text="$t('sw-cms.elements.general.config.helpText.speed')"
                />
            {% endblock %}
        </div>

        <mt-banner
                class="sw-cms-el-config-acris-blog-image-slider__setting-auto-slide"
                variant="attention"
                :title="$t('sw-cms.elements.general.config.infoText.autoSlideTitle')"
        >
            <p class="sw-cms-el-config-acris-blog-image-slider__setting-auto-slide-attention">
                {{ $t('sw-cms.elements.general.config.infoText.autoSlide') }}
            </p>

            <div class="sw-cms-el-config-acris-blog-image-slider__setting-auto-slide-container sw-cms-el-config-acris-blog-image-slider__setting-option">
                <div class="sw-cms-el-config-acris-blog-image-slider__setting-auto-slide-switch">
                    {% block sw_cms_element_acris_blog_image_slider_config_settings_auto_slide %}
                        <mt-switch
                                v-model="element.config.autoSlide.value"
                                class="sw-cms-el-config-acris-blog-image-slider__setting-auto-slide"
                                :label="$t('sw-cms.elements.general.config.label.autoSlide')"
                                bordered
                                @update:model-value="onChangeAutoSlide"
                        />
                    {% endblock %}
                </div>

                <div class="sw-cms-el-config-acris-blog-image-slider__setting-auto-slide-delay">
                    {% block sw_cms_element_acris_blog_image_slider_config_settings_autoplay_timeout %}
                        <mt-number-field
                                v-model="element.config.autoplayTimeout.value"
                                class="sw-cms-el-config-acris-blog-image-slider__setting-delay-slide"
                                number-type="int"
                                :min="0"
                                :max="3600000"
                                :label="$t('sw-cms.elements.general.config.label.autoplayTimeout')"
                                :placeholder="$t('sw-cms.elements.general.config.label.autoplayTimeout')"
                                :help-text="$t('sw-cms.elements.general.config.helpText.autoplayTimeout')"
                        />
                    {% endblock %}
                </div>
            </div>
        </mt-banner>

        <mt-switch
                class="sw-cms-el-config-acris-blog-image-slider__settings-is-decorative"
                :model-value="element.config.isDecorative.value"
                :label="$t('sw-cms.elements.image.config.label.isDecorative')"
                :help-text="$t('sw-cms.elements.image.config.label.isDecorativeHelpText')"
                bordered
                @update:model-value="onChangeIsDecorative"
        />
    </div>
{% endblock %}